// src/pages/TransactionEntry/index.js
import TransactionEntryPage from "./TransactionEntryPage";

export default TransactionEntryPage;
